import React, { useState } from "react";
import {
  normaliseFuelType,
  SUPPLIER_FUEL_TYPE,
} from "../../constants/tariffInfo";
import { useTariff } from "../../context/TariffContext";
import EN from "../../locales/en.json";
import EditTariffModal from "../CurrentTariff/EditTariffModal";
import RippleLoader from "../RippleLoader";
import PriceCapTariffInfoPanel from "./PriceCapTariffInfoPanel";

const QuotesHeader = ({ setShowHowSavingsCalculatedModal }) => {
  const {
    estimatedMonthlySpend,
    estimatedMonthlyKwhsElec,
    estimatedMonthlyKwhsGas,
    existingTariffElec,
    userDefinedTariffInfo,
    combinedTariffInfo,
  } = useTariff();

  const fuelType = normaliseFuelType(combinedTariffInfo?.fuelType);

  const hasToldUskWhs =
    !!userDefinedTariffInfo?.existingkWhsElec ||
    !!userDefinedTariffInfo?.existingkWhsGas;

  const [showUpdateUsageModal, setShowUpdateUsageModal] = useState(false);

  const onPriceCapTariff = existingTariffElec?.tilTariffTypeElec === "Variable";

  return (
    <>
      <div className="mb-6">
        <div>
          <h1 className="text-[40px] font-bold leading-[1.2] text-center">
            {EN.quotes.quotes_header.title}
          </h1>

          {onPriceCapTariff && <PriceCapTariffInfoPanel />}

          <h3 className="mt-4 max-w-4xl text-md leading-[1.5] text-center">
            {hasToldUskWhs
              ? EN.quotes.quotes_header.usage_info.user_provided
              : EN.quotes.quotes_header.usage_info.calculated}
          </h3>
        </div>

        {(estimatedMonthlyKwhsElec || estimatedMonthlyKwhsGas) &&
        estimatedMonthlySpend ? (
          <>
            <p className="mt-2 max-w-4xl text-md leading-[1.5] text-center">
              {fuelType !== SUPPLIER_FUEL_TYPE.GAS && (
                <strong>
                  {Math.round(estimatedMonthlyKwhsElec)}
                  {
                    EN.quotes.quotes_header.energy_usage_summary
                      .electricity_text
                  }
                </strong>
              )}
              {fuelType === SUPPLIER_FUEL_TYPE.ELECGAS && (
                <>
                  {" "}
                  {EN.quotes.quotes_header.energy_usage_summary.and}{" "}
                  <strong>
                    {Math.round(estimatedMonthlyKwhsGas)}
                    {EN.quotes.quotes_header.energy_usage_summary.gas_text}
                  </strong>
                </>
              )}
              {fuelType === SUPPLIER_FUEL_TYPE.GAS && (
                <strong>
                  {Math.round(estimatedMonthlyKwhsGas)}
                  {EN.quotes.quotes_header.energy_usage_summary.gas_text}
                </strong>
              )}{" "}
              per month.{" "}
              {EN.quotes.quotes_header.energy_usage_summary.estimated_payment}{" "}
              <strong>£{estimatedMonthlySpend}</strong>{" "}
              {EN.quotes.quotes_header.energy_usage_summary.per_month}.
            </p>
            <div className="flex flex-col md:flex-row justify-between mt-2">
              <button
                className="text-primary underline inline-block text-center"
                onClick={() => setShowUpdateUsageModal(true)}
              >
                {EN.quotes.quotes_header.buttons.update_usage}
              </button>
              <span className="hidden md:block">|</span>
              <button
                className="text-primary underline inline-block text-center"
                onClick={() => setShowHowSavingsCalculatedModal(true)}
              >
                {EN.quotes.quotes_header.buttons.how_savings_calculated}
              </button>
            </div>
          </>
        ) : (
          <div className="mt-2">
            <RippleLoader width="w-full" />
          </div>
        )}
      </div>

      <EditTariffModal
        open={showUpdateUsageModal}
        setOpen={setShowUpdateUsageModal}
      />
    </>
  );
};

export default QuotesHeader;
